import React, { Component } from 'react';
import { rootDomainUrl } from '../config/Config';
const $ = window.$;

export default class Ourtechnology extends Component {
  componentDidMount() {
    setTimeout(() => {
      $(".fancybox").fancybox({
        autoPlay: true, //  slideshow will start after opening the first gallery item
        playSpeed: 3000 // 3sec pause between changing next item
      });
      $('.fancybox-media')
        .attr('rel', 'media-gallery')
        .fancybox({
          openEffect: 'none',
          closeEffect: 'none',
          prevEffect: 'none',
          nextEffect: 'none',
          arrows: false,
          autoPlay: true,
          playSpeed: 3000,
          helpers: {
            media: {},
            buttons: {}
          }
        });
    }, 100);
  }

  render() {
    return (
      <section className="video-section">
        <div className="row">
          <div className="video-lft"> <a className="fancybox-media" href="https://www.youtube.com/embed/SdxoGmqiE9Y"><img src={rootDomainUrl + '361dm_corporate/corporateimg/video-image.jpg'} alt="" />
            <div className="video-icon"></div>
          </a> </div>
          <div className="video-txt-rgt">
            <div className="video-txt-top">
              <div className="book-ico"></div>
              <h2>Our <span>technology</span> catalyzes new ways <br />
                of learning. A <span> new  pedagogy </span> <br />
                is thus
               emerging.</h2>
            </div>
            <div className="video-txt-btm">
              <p>At 361DM, we combine the best of classroom<br />
                learning experience with the flexibility <br />
                of online education.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/partials/Ourtechnology.js